import axios from 'axios';
import Vue from 'vue';

const state = {
    all: [],
    contents: {},
    active: null
};

const mutations = {
    load(state, products){
        while(state.all.length){
            state.all.pop();
        }

        for(const product of products){
            state.all.push(product);
        }
    },
    add(state, product){
        state.all.push(product);
    },
    remove(state, product){
        state.all.splice(state.all.indexOf(product), 1);

        if(state.active === product){
            state.active = null;
        }
    },
    activate(state, product){
        if(product){
            state.active = product;
        }
    },
    snapshots(state, {product, snapshots}){
        const found = state.all.find(p => p.id.toString() === product);

        if(!found){
            throw new Error('Invalid product.');
        }

        var snaps = snapshots || [];
        if( 
            state.active?.metadata?.package_content_sort !== undefined
            && Array.isArray(state.active.metadata.package_content_sort) 
        ) {  //check sort is existing
            var sortedList = [];
            
            state.active.metadata.package_content_sort.forEach( (val) => {
                if(snaps.filter( f => f.id === val )[0]) { // reordering snapshot

                    sortedList.push(snaps.filter( f => f.id === val )[0]);
                    snaps = snaps.filter( f => f.id !== val );
                }
            })
            snaps = sortedList.concat(snaps);
        } else { // default setup for sort 
            snaps = snapshots.sort((a, b) => {
                return (new Date(a.dateUpdated) < new Date(b.dateUpdated)) ? -1 : 1;
            });
        }
        console.log('product',state.active.product?.metadata?.allow_package_printing );
        if( 
            state.active?.product?.metadata?.allow_package_printing !== undefined
        ) {
            
            if( state.active?.product?.metadata?.allow_package_printing ) {
                localStorage.setItem('allow_package_printing','true');
            } else {
                localStorage.removeItem('allow_package_printing')
            }
        } else {
            localStorage.removeItem('allow_package_printing')
        }

        if(snaps.length > 0 ) {
            Vue.set(found, 'snapshots', snaps);
        }
             
    },
    contents(state, {product, contents}){
        const found = state.all.find(p => p.id.toString() === product);

        if(!found){
            throw new Error('Invalid product.');
        }

        const parents = new Map();

        //Create a map of all parents and their children so we can build a tree in O(n) time.
        //This way, we really only loop through the contents array twice (once to build the map and once to build the tree).
        for(const content of contents){
            if(!parents.has(content.parent.id)){
                parents.set(content.parent.id, []);
            }

            parents.get(content.parent.id).push(content);
        }

        for(const content of contents){
            if(parents.has(content.id)){
                content.children = parents.get(content.id);
            }else{
                content.children = [];
            }

            if(content.type === 'project'){
                //Only show the units and sort them correctly.
                content.children = content.children
                .filter(c => c.type === 'unit')
                .sort((a, b) => {
                    return (content.data.units.indexOf(a.data.guid) < content.data.units.indexOf(b.data.guid)) ? -1 : 1;
                });
            }

            if(content.type === 'unit'){
                //Sort our children in the correct order.
                content.children = content.children
                .sort((a, b) => {
                    return (content.data.resources.indexOf(a.data.guid) < content.data.resources.indexOf(b.data.guid)) ? -1 : 1;
                });
            }
        }

        console.log('committing sorted contents');
        //We want to rearrange this array into a nice tree, starting with `projects`.
        const sorted = contents
        .filter(c => c.type === 'project')
        .sort((a, b) => {
            return (new Date(a.dateUpdated) < new Date(b.dateUpdated)) ? -1 : 1;
        });

        console.log(sorted)

        console.log('setting committed contents');
        Vue.set(found, 'contents', sorted);
        console.log('done');
    },
    clear(state){
        this.all = [];
        this.active = null;
    }
};

const actions = {
    load({commit, dispatch}){
        return axios.get('/products')
        .then(response => commit('load', response.$data))
        .catch(error => console.log(error));
    },
    add({commit}, product){
        commit('add', product);
    },
    remove({commit, state}, product){
        commit('remove', product);
    },
    activate({commit, state}, product){
        if(state.active && state.active.id === product){
            return;
        }

        const activate = state.all.find(p => p.id.toString() === product);

        if(activate){
            commit('activate', activate);
        }
    },
    snapshots({commit, state}, product){
        const found = state.all.find(p => p.id.toString() === product);

        if(!found){
            return Promise.reject('Invalid product.');
        }

        if(found.snapshots){
            return found.snapshots;
        }

        return axios.get(`/products/${product}/snapshots`)
        .then(response => {
            commit('snapshots', {
                product,
                snapshots: response.$data
            });
        });
    },
    contents({commit, state}, product){
        const found = state.all.find(p => p.id.toString() === product);
        console.log('product action',found);
        if(!found){
            return Promise.reject('Invalid product.');
        }

        if(!found.snapshots){
            return Promise.reject('Snapshots must be loaded before contents.');
        }

        if(found.contents){
            return;
        }

        return Promise.all([
            axios.get('/contents', {
                params: {
                    collectionId: product,
                    parentTypes: 'project',
                    type: 'unit',
                    count: 1000
                }
            }),
            axios.get('/contents', {
                params: {
                    collectionId: product,
                    parentTypes: 'unit',
                    type: 'project,assignment,lesson,page,quiz,attachment,lessonPlan',
                    count: 1000
                }
            })
        ])
        .then(([units_response, contents_response]) => {
            commit('contents', {
                product,
                contents: [].concat(found.snapshots, units_response.$data, contents_response.$data)
            });
        });
    },
    clear({commit}){
        commit('clear');
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
